import React, { useState } from 'react';
import AuthHeader from '@apps/components/AuthHeader';
import LoginContainer from '@apps/containers/LoginContainer';
import { Box, Link, Typography } from '@mui/material';
import { PageType, SideCover } from '@stack/components';
import NextLink from 'next/link';

const LoginScreen = () => {
  // ======================= VARIABLES

  // ======================= STATE
  const [isOtpLogin, setIsOtpLogin] = useState(false);

  // ======================= VIEWS
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: { xs: '100%', lg: '60%' },
          height: { xs: '100%', lg: '100vh' },
          justifyContent: 'center',
          order: { xs: 1, lg: 0 },
          marginTop: { xs: '20px', lg: 0 },
        }}
      >
        <Box
          sx={{
            minWidth: 200,
            maxWidth: 500,
            width: '90%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <AuthHeader title={isOtpLogin ? 'Security' : 'Login'}>
            <>
              {!isOtpLogin && (
                <Typography color={'secondary'} variant="subtitle1">
                  Welcome back!
                </Typography>
              )}
            </>
            <Typography color={'secondary'} variant="subtitle1">
              No account yet?
              <Link
                sx={{ ml: 1 }}
                href={'/register'}
                variant={'subtitle1'}
                component={NextLink}
              >
                Sign up now
              </Link>
            </Typography>
          </AuthHeader>

          <Box sx={{ mt: 12.5 }}>
            <LoginContainer
              isOtpLogin={isOtpLogin}
              onSetIsOtpLogin={(value) => {
                setIsOtpLogin(value);
              }}
            />
          </Box>
        </Box>
      </Box>
      <SideCover pageType={PageType.MAIN} />
    </Box>
  );
};

export default LoginScreen;
